<template>

<div class="quiz">

	<com-headmain :simple="true" />

	<div class="quiz-content">

		<div class="quiz-title">{{ section.patient.title || section.text.title }}<div class="subsection-close" v-on:click="$emit('back')"></div></div>

		<div class="quiz-intro" v-if="section.intro && !started" v-html="section.intro"></div>

		<template v-if="!complete">

			<div class="quiz-progress">Question {{ currentIndex + 1 }} of {{ questions.length }}</div>

			<div class="quiz-question" v-if="currentQuestion">

				<div class="quiz-question-text">{{ currentQuestion.text }}</div>

				<div class="quiz-question-actions" v-if="!revealed">

					<button class="quiz-question-button" v-on:click="onAnswer(1)">True</button>
					<button class="quiz-question-button" v-on:click="onAnswer(0)">False</button>

				</div>

				<div class="quiz-question-result" v-if="revealed" :class="{'is-correct': isCorrect, 'is-incorrect': !isCorrect}">

					<div class="quiz-question-result-icon">
						<i class="fa-solid" :class="isCorrect ? 'fa-check' : 'fa-xmark'"></i>
					</div>

					<div class="quiz-question-result-text" v-html="currentQuestion.explanation"></div>

				</div>

				<button class="quiz-next-button" v-if="revealed" v-on:click="onNext">{{ isLast ? 'See Results' : 'Next Question' }}</button>

			</div>

		</template>

		<template v-if="complete">

			<div class="quiz-complete">

				<div class="quiz-complete-score">{{ correctCount }} / {{ questions.length }}</div>

				<div class="quiz-complete-text" v-if="section.complete" v-html="section.complete"></div>

				<button class="quiz-next-button" v-on:click="$emit('next')">Continue</button>

			</div>

		</template>

	</div>

</div>

</template>

<script>

import comHeadMain from './../../common/Head'

export default {

	props: ['section'],

	components: {
		'com-headmain': comHeadMain
	},

	data: function() {

		return {
			currentIndex: 0,
			answers: {},
			revealed: false,
			complete: false,
			started: true
		}

	},

	computed: {

		questions: function() {

			return this.section.questions || []

		},

		currentQuestion: function() {

			return this.questions[this.currentIndex] || null

		},

		isCorrect: function() {

			if (!this.currentQuestion) return false
			return this.answers[this.currentQuestion.id] === this.currentQuestion.answer

		},

		isLast: function() {

			return this.currentIndex === this.questions.length - 1

		},

		correctCount: function() {

			var self = this
			var count = 0

			this.$_.each(this.questions, function(q) {
				if (self.answers[q.id] === q.answer) count++
			})

			return count

		}

	},

	methods: {

		onAnswer: function(value) {

			this.$set(this.answers, this.currentQuestion.id, value)
			this.revealed = true

		},

		onNext: function() {

			if (this.isLast) {

				this.complete = true

			} else {

				this.currentIndex++
				this.revealed = false

			}

		}

	}

}

</script>

<style scoped>

.quiz {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

.is-tablet .quiz { left: 64px; }
.is-mobile .quiz { left: 0px; }

.quiz-content {
	width: 100%;
	max-width: 800px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-mobile .quiz-content { padding: 80px 15px 85px 15px; }

.quiz-title {
	font-weight: 100;
	font-size: 36px;
	line-height: 36px;
	letter-spacing: 3px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 48px;
}

.quiz-title:after { content: ' '; position: absolute; bottom: -16px; left: 0px; height: 4px; background-color: var(--aid-color); width: 150px; }

.is-mobile .quiz-title { font-size: 18px; line-height: 18px; margin-bottom: 32px; }

.quiz-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 32px; }

.quiz-progress { font-size: 14px; color: #888; text-transform: uppercase; letter-spacing: 1px; font-weight: 600; margin-bottom: 16px; }

.quiz-question-text {
	font-size: 24px;
	font-weight: 600;
	color: #343434;
	line-height: 32px;
	margin-bottom: 32px;
}

.is-mobile .quiz-question-text { font-size: 18px; line-height: 26px; }

.quiz-question-actions { display: flex; gap: 16px; }

.is-mobile .quiz-question-actions { flex-direction: column; }

.quiz-question-button {
	flex: 1;
	padding: 18px 32px;
	border-radius: 32px;
	font-size: 18px;
	font-weight: 700;
	border: 2px solid var(--aid-color);
	background-color: transparent;
	color: #343434;
	cursor: pointer;
	transition: all 300ms ease-in-out;
}

.quiz-question-button:hover { background-color: var(--aid-color); color: #fff; }

.quiz-question-result {
	display: flex;
	align-items: flex-start;
	padding: 24px;
	border-radius: 16px;
	margin-bottom: 24px;
}

.quiz-question-result.is-correct { background-color: #e8f5e9; }
.quiz-question-result.is-incorrect { background-color: #fce4ec; }

.quiz-question-result-icon {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 16px;
}

.is-correct .quiz-question-result-icon { background-color: #4CAF50; }
.is-incorrect .quiz-question-result-icon { background-color: #ee7173; }

.quiz-question-result-icon i { color: #fff; font-size: 18px; }

.quiz-question-result-text { font-size: 16px; color: #343434; line-height: 24px; flex: 1; }
.is-mobile .quiz-question-result-text { font-size: 14px; line-height: 22px; }

.quiz-next-button {
	padding: 14px 40px;
	border-radius: 32px;
	font-size: 16px;
	font-weight: 600;
	background-color: var(--aid-color);
	color: #fff;
	border: none;
	cursor: pointer;
	transition: all 300ms ease-in-out;
	align-self: flex-start;
}

.quiz-next-button:hover { filter: brightness(90%); }

.is-mobile .quiz-next-button { width: 100%; text-align: center; }

.quiz-complete { text-align: center; }

.quiz-complete-score {
	font-size: 64px;
	font-weight: 700;
	color: #343434;
	margin-bottom: 16px;
}

.quiz-complete-text { font-size: 18px; color: #666; line-height: 28px; margin-bottom: 32px; }

</style>
